<div class="content font-color" *ngIf="files">
  <span class="files-title">Anexos</span>
  <div *ngFor="let file of files" class="files">
    <div class="files-item" fxLayout="row" fxLayoutAlign="space-between center">
      <div fxLayout="column" (click)="downloadFile(file)" class="clickable">
        <span>{{file.name}}</span>
      </div>
    </div>
    <mat-divider>
    </mat-divider>
  </div>
</div>

